const STYLE = document.body.style;

export const COLOR = {
    BLACK: '#000000',
    BLACK_4UP: '#292929',
    BLACK_8UP: '#525252',

    WHITE: '#ffffff',
    WHITE_2DOWN: '#ebebeb',
    WHITE_4DOWN: '#d6d6d6',
    WHITE_8DOWN: '#adadad',

    RED: '#fc424a',
    GREEN: '#00d25b',

    GRAY: '#191c24',
    GRAY_2UP: '#292e3b',
    GRAY_6UP: '#495269',
    GRAY_10UP: '#6c7293'
};
export const MAIN_COLOR = {
    blue: {
        MAIN_4UP: '#36b3ff',
        MAIN_2UP: '#0fa5ff',
        MAIN: '#0090e7',
        MAIN_2DOWN: '#0078c0',
        MAIN_4DOWN: '#005f99'
    },
    orange: {
        MAIN_4UP: '#ffc54e',
        MAIN_2UP: '#ffb827',
        MAIN: '#ffab00',
        MAIN_2DOWN: '#d89100',
        MAIN_4DOWN: '#b17600'
    },
    purple: {
        MAIN_4UP: '#bfa4f2',
        MAIN_2UP: '#a781ed',
        MAIN: '#8f5fe8',
        MAIN_2DOWN: '#773de3',
        MAIN_4DOWN: '#601fd9'
    },
    brown: {
        MAIN_4UP: '#9e595c',
        MAIN_2UP: '#854b4e',
        MAIN: '#6c3d3f',
        MAIN_2DOWN: '#532f30',
        MAIN_4DOWN: '#3a2122'
    },
    green: {
        MAIN_4UP: '#74cc97',
        MAIN_2UP: '#57c182',
        MAIN: '#41B06E',
        MAIN_2DOWN: '#36935c',
        MAIN_4DOWN: '#2c774a'
    },
    pink: {
        MAIN_4UP: '#de4b79',
        MAIN_2UP: '#e46c91',
        MAIN: '#ea8daa',
        MAIN_2DOWN: '#f0aec3',
        MAIN_4DOWN: '#f6cfdb'
    },
    custom: {
        MAIN_4UP: 'rgb(0,0,0)',
        MAIN_2UP: 'rgb(0,0,0)',
        MAIN: 'rgb(0,0,0)',
        MAIN_2DOWN: 'rgb(0,0,0)',
        MAIN_4DOWN: 'rgb(0,0,0)'
    }
}


const LIGHT_THEME = {
    '--main-color': 'M.MAIN',
    '--background': COLOR.WHITE,
    '--background-text': COLOR.BLACK,
    '--background-separator': COLOR.WHITE_4DOWN,
    '--background-color': COLOR.WHITE,
    '--background-secondary': COLOR.WHITE_4DOWN,
    '--background-hover': COLOR.WHITE_2DOWN,
    '--border-color': COLOR.WHITE_4DOWN,
    '--text-color': COLOR.BLACK,
    '--text-color-secondary': COLOR.BLACK_8UP,
    '--primary-color': 'M.MAIN',
    '--left-panel': 'M.MAIN',
    '--left-header': 'M.MAIN_4DOWN',
    '--left-separator': 'M.MAIN_4UP',
    '--left-button': COLOR.WHITE,
    '--left-button-text': COLOR.GRAY,
    '--left-button-hover': COLOR.WHITE_4DOWN,
    '--left-button-disable': COLOR.WHITE_8DOWN,
    '--left-toggle-hover': 'M.MAIN_2UP',
    '--header': COLOR.WHITE_4DOWN,
    '--header-text': COLOR.BLACK,
    '--header-separator': COLOR.WHITE_2DOWN,
    '--header-button': 'M.MAIN',
    '--header-button-text': COLOR.WHITE,
    '--header-button-hover': 'M.MAIN_2UP',
    '--header-button-disable': 'M.MAIN_4DOWN',
    '--tag-new': COLOR.GREEN,
    '--tag-full': COLOR.WHITE_8DOWN,
    '--tag-not-full': 'M.MAIN',
    '--image-hover': COLOR.WHITE_8DOWN,
    '--filter-header': COLOR.WHITE_4DOWN,
    '--filter-header-text': COLOR.BLACK,
    '--filter-text-disable': COLOR.BLACK_8UP,
    '--border': `1px solid ${COLOR.BLACK}`,
    '--tag': COLOR.WHITE,
    '--tag-text': COLOR.BLACK,
    '--tag-add': COLOR.GREEN,
    '--tag-remove': COLOR.RED
};
const DARK_THEME = {
    '--main-color': 'M.MAIN',
    '--background': COLOR.BLACK,
    '--background-text': COLOR.WHITE,
    '--background-separator': COLOR.GRAY,
    '--background-color': COLOR.GRAY,
    '--background-secondary': COLOR.GRAY_2UP,
    '--background-hover': COLOR.GRAY_6UP,
    '--border-color': COLOR.GRAY_2UP,
    '--text-color': COLOR.WHITE,
    '--text-color-secondary': COLOR.GRAY_10UP,
    '--primary-color': 'M.MAIN',
    '--left-panel': COLOR.GRAY,
    '--left-header': 'M.MAIN',
    '--left-separator': COLOR.GRAY_2UP,
    '--left-button': 'M.MAIN',
    '--left-button-text': COLOR.WHITE,
    '--left-button-hover': 'M.MAIN_2UP',
    '--left-button-disable': 'M.MAIN_4DOWN',
    '--left-toggle-hover': 'M.MAIN_2UP',
    '--header': COLOR.GRAY,
    '--header-text': COLOR.WHITE,
    '--header-separator': COLOR.GRAY_2UP,
    '--header-button': 'M.MAIN',
    '--header-button-text': COLOR.WHITE,
    '--header-button-hover': 'M.MAIN_2UP',
    '--header-button-disable': 'M.MAIN_4DOWN',
    '--tag-new': COLOR.GREEN,
    '--tag-full': COLOR.GRAY_2UP,
    '--tag-not-full': 'M.MAIN',
    '--image-hover': COLOR.GRAY_6UP,
    '--filter-header': COLOR.BLACK,
    '--filter-header-text': COLOR.GRAY_10UP,
    '--filter-text-disable': COLOR.GRAY_10UP,
    '--border': '1px solid transparent',
    '--tag': 'M.MAIN',
    '--tag-text': COLOR.WHITE,
    '--tag-add': COLOR.GREEN,
    '--tag-remove': COLOR.RED
};


export async function changeTheme(isDark, mainColor) {
    const theme = isDark === true ? DARK_THEME : LIGHT_THEME;
    const mainTheme = MAIN_COLOR[mainColor];

    Object.keys(theme).forEach((keyName, keyIndex) => {
        const colorName = theme[keyName].split('.');
        if (colorName.length > 1) {
            STYLE.setProperty(keyName, mainTheme[colorName[1]]);
        }
        else STYLE.setProperty(keyName, theme[keyName]);
    });
}

export async function updateCustomColor(name, color) {
    MAIN_COLOR.custom[name] = color;
}
